var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('background-image: url('+_vm.bg+');background-size: cover;width:100%;height: 100%;position:absolute;')})}
var staticRenderFns = []

export { render, staticRenderFns }